var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.column.display == 'default')?_c('span',[_vm._v(_vm._s(_vm.item[_vm.column.value])+" ")]):_c(_vm.column.display,{tag:"v-component",attrs:{"column":_vm.column,"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }